<template>
  <button
    type="button"
    @click.prevent="handleClick"
    class="inline-flex cursor-pointer items-center gap-1.5 rounded transition hover:text-zinc-600 focus:outline-none focus:ring focus:ring-primary-200 dark:hover:text-zinc-200 dark:focus:ring-zinc-700"
    :dusk="'sort-' + uriKey"
    :aria-sort="ariaSort"
  >
    <span class="inline-flex text-xs font-semibold uppercase tracking-wide text-zinc-400">
      <slot />
    </span>

    <svg
      class="size-3.5 shrink-0"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
    >
      <path
        :class="descClass"
        d="M1.70710678 4.70710678c-.39052429.39052429-1.02368927.39052429-1.41421356 0-.3905243-.39052429-.3905243-1.02368927 0-1.41421356l3-3c.39052429-.3905243 1.02368927-.3905243 1.41421356 0l3 3c.39052429.39052429.39052429 1.02368927 0 1.41421356-.39052429.39052429-1.02368927.39052429-1.41421356 0L4 2.41421356 1.70710678 4.70710678z"
      />
      <path
        :class="ascClass"
        d="M6.29289322 9.29289322c.39052429-.39052429 1.02368927-.39052429 1.41421356 0 .39052429.39052429.39052429 1.02368928 0 1.41421358l-3 3c-.39052429.3905243-1.02368927.3905243-1.41421356 0l-3-3c-.3905243-.3905243-.3905243-1.02368929 0-1.41421358.3905243-.39052429 1.02368927-.39052429 1.41421356 0L4 11.5857864l2.29289322-2.29289318z"
      />
    </svg>
  </button>
</template>

<script>
import { InteractsWithQueryString } from '@/mixins'

export default {
  emits: ['sort', 'reset'],

  mixins: [InteractsWithQueryString],

  props: {
    resourceName: String,
    uriKey: String,
  },

  inject: ['orderByParameter', 'orderByDirectionParameter'],

  methods: {
    handleClick() {
      if (this.isSorted && this.isDescDirection) {
        this.$emit('reset')
      } else {
        this.$emit('sort', {
          key: this.uriKey,
          direction: this.direction,
        })
      }
    },
  },

  computed: {
    isDescDirection() {
      return this.direction == 'desc'
    },

    isAscDirection() {
      return this.direction == 'asc'
    },

    ascClass() {
      if (this.isSorted && this.isDescDirection) {
        return 'fill-brand-500'
      }

      if (this.isSorted && this.isAscDirection) {
        return 'fill-zinc-400 dark:fill-zinc-500'
      }

      return 'fill-zinc-300 dark:fill-zinc-600'
    },

    descClass() {
      if (this.isSorted && this.isAscDirection) {
        return 'fill-brand-500'
      }

      if (this.isSorted && this.isDescDirection) {
        return 'fill-zinc-400 dark:fill-zinc-500'
      }

      return 'fill-zinc-300 dark:fill-zinc-600'
    },

    isSorted() {
      return (
        this.sortColumn == this.uriKey &&
        ['asc', 'desc'].includes(this.direction)
      )
    },

    sortKey() {
      return this.orderByParameter
    },

    sortColumn() {
      return this.queryStringParams[this.sortKey]
    },

    directionKey() {
      return this.orderByDirectionParameter
    },

    direction() {
      return this.queryStringParams[this.directionKey]
    },

    notSorted() {
      return !!!this.isSorted
    },

    ariaSort() {
      if (this.isDescDirection) {
        return 'descending'
      } else if (this.isAscDirection) {
        return 'ascending'
      }

      return 'none'
    },
  },
}
</script>
